import { PointCounter } from "./point-counter";

export class FreqPointCounter extends PointCounter {
  constructor(settings) {
    super(settings);
  }

  calculatePointCount() {
    return this.settings.freq * (this.settings.width / this.settings.ppmm);
  }
}
